export enum Language {
  FRANCAIS = "Français",
  ANGLAIS = "Anglais",
}
